// import styles from "./Styles/Footer.module.scss";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faLocationDot,
//   faSquarePhone,
//   faEnvelope,
// } from "@fortawesome/free-solid-svg-icons";
// import { faCopyright } from "@fortawesome/free-regular-svg-icons";
// import {
//   faSquareFacebook,
//   faSquareWhatsapp,
//   faSquareInstagram,
//   faSquareYoutube,
//   faLinkedin,
// } from "@fortawesome/free-brands-svg-icons";
// import TopGeCounter from "./Datas/TopGeCounter";

// function Footer() {
//   const handleCallClick = () => {
//     window.location.href = `tel:550059196`;
//   };

//   const handleWhatsAppClick = (phoneNumber: string) => {
//     const whatsappUrl = `https://wa.me/+995${phoneNumber}`;
//     window.location.href = whatsappUrl;
//   };

//   const handleEmailClick = (email: string) => {
//     const subject = encodeURIComponent("გამარჯობა!");
//     const body = encodeURIComponent("");
//     window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
//   };

//   return (
//     <>
//       <div className={styles.parentContainer}>
//         <div className={styles.mainContainer}>
//           <footer className={styles.footer}>
//             <div className={styles.footer__leftSide}>
//               <div className={styles.footer__leftSide__childContainer}>
//                 <div className={styles.footer__leftSide__aboutUs}>
//                   <p>
//                     ჩვენი მიზანია, მოგეხმაროთ სასურველი სპეციალისტის მოძიებაში
//                     ხელსაყრელ ფასად, სასურველ ლოკაციაზე და შესაბამისი
//                     გამოცდილებით.
//                   </p>
//                 </div>

//                 <div className={styles.footer__leftSide__privacyAndPolicyBtn}>
//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     href="https://xeloba.ge/privacy-and-policy"
//                   >
//                     <span>წესები და პირობები</span>
//                   </a>
//                 </div>

//                 <div className={styles.footer__leftSide__QandA}>
//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     href="https://xeloba.ge/Q&A"
//                   >
//                     <span>ხშირად დასმული კითხვები</span>
//                   </a>
//                 </div>
//               </div>
//             </div>

//             <div className={styles.footer__rightSide}>
//               <div className={styles.footer__rightSide__childContainer}>
//                 <div className={styles.footer__rightSide__location}>
//                   <FontAwesomeIcon
//                     icon={faLocationDot}
//                     className={styles.faLocationDot}
//                   />
//                   <span> ქ. თბილისი, რეზო გაბაშვილის N10</span>
//                 </div>

//                 <div
//                   className={styles.footer__rightSide__contact}
//                   onClick={() => handleEmailClick("info@xeloba.ge")}
//                 >
//                   <FontAwesomeIcon
//                     icon={faEnvelope}
//                     className={styles.faEnvelope}
//                   />
//                   <span>info@xeloba.ge</span>
//                 </div>

//                 <div
//                   className={styles.footer__rightSide__contact}
//                   onClick={() => handleCallClick()}
//                 >
//                   <FontAwesomeIcon
//                     icon={faSquarePhone}
//                     className={styles.faSquarePhone}
//                   />
//                   <span>550 05 91 96</span>
//                 </div>

//                 <div className={styles.footer__rightSide__socialNetworks}>
//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     href="https://www.facebook.com/people/%E1%83%AE%E1%83%94%E1%83%9A%E1%83%9D%E1%83%91%E1%83%90-Xeloba/61555048217915/"
//                   >
//                     <FontAwesomeIcon
//                       icon={faSquareFacebook}
//                       className={styles.faFacebook}
//                     />
//                   </a>

//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     href="https://www.instagram.com/xeloba7?igsh=MWFrNmxzemt4ZmgzZA=="
//                   >
//                     <FontAwesomeIcon
//                       icon={faSquareInstagram}
//                       className={styles.faSquareInstagram}
//                     />
//                   </a>

//                   <FontAwesomeIcon
//                     icon={faSquareWhatsapp}
//                     className={styles.faSquareWhatsapp}
//                     onClick={() => handleWhatsAppClick("550059196")}
//                   />

//                   <FontAwesomeIcon
//                     icon={faSquareYoutube}
//                     className={styles.faSquareYoutube}
//                   />
//                 </div>
//               </div>
//             </div>
//           </footer>
//         </div>

//         <div className={styles.copyright}>
//           <div className={styles.copyright__text}>
//             <FontAwesomeIcon
//               icon={faCopyright}
//               className={styles.faCopyright}
//             />
//             <span>{`2025 "xeloba.ge" ყველა უფლება დაცულია`}</span>
//           </div>
//         </div>

//         <div className={styles.creatorContainer}>
//           <div className={styles.creator}>
//             <p>Developed By:</p>
//             <p>Giorgi Otarashvili</p>
//             <a
//               target="_blank"
//               rel="noopener noreferrer"
//               href="https://www.linkedin.com/in/gio-otarashvili-ba2175271?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
//             >
//               <FontAwesomeIcon
//                 icon={faLinkedin}
//                 className={styles.devsocialNetwork}
//               />
//             </a>

//             <FontAwesomeIcon
//               icon={faEnvelope}
//               className={styles.devsocialNetwork}
//               onClick={() => handleEmailClick("giootarashvili77@gmail.com")}
//             />

//             <FontAwesomeIcon
//               icon={faSquareWhatsapp}
//               className={styles.devsocialNetwork}
//               onClick={() => handleWhatsAppClick("511410903")}
//             />
//           </div>
//         </div>

//         <div className={styles.counterContainer}>
//           <div className={styles.counter}>
//             <TopGeCounter />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Footer;

/////////////////
import styles from "./Styles/Footer.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faSquarePhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import {
  faSquareFacebook,
  faSquareWhatsapp,
  faSquareInstagram,
  faSquareYoutube,
  faLinkedin,
  faCcVisa,
  faCcMastercard,
  faCcAmex,
} from "@fortawesome/free-brands-svg-icons";
import TopGeCounter from "./Datas/TopGeCounter";
import EmailObfuscate from "./Hidden email/EmailObfuscate";

function Footer() {
  const handleCallClick = () => {
    window.location.href = `tel:550059196`;
  };

  const handleWhatsAppClick = (phoneNumber: string) => {
    const whatsappUrl = `https://wa.me/+995${phoneNumber}`;
    window.location.href = whatsappUrl;
  };

  const handleEmailClick = (email: string) => {
    const subject = encodeURIComponent("გამარჯობა!");
    const body = encodeURIComponent("");
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <div className={styles.parentContainer}>
        <div className={styles.mainContainer}>
          <footer className={styles.footer}>
            <div className={styles.footer__leftSide}>
              <div className={styles.footer__leftSide__childContainer}>
                <div className={styles.footer__leftSide__aboutUs}>
                  <p>
                    ჩვენი მიზანია, მოგეხმაროთ სასურველი სპეციალისტის მოძიებაში
                    ხელსაყრელ ფასად, სასურველ ლოკაციაზე და შესაბამისი
                    გამოცდილებით.
                  </p>
                </div>

                  <div className={styles.footer__leftSide__partners}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://xeloba.ge/partners"
                  >
                    <span>პარტნიორები</span>
                  </a>
                </div>

                <div className={styles.footer__leftSide__privacyAndPolicyBtn}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://xeloba.ge/privacy-and-policy"
                  >
                    <span>წესები და პირობები</span>
                  </a>
                </div>

                <div className={styles.footer__leftSide__QandA}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://xeloba.ge/Q&A"
                  >
                    <span>ხშირად დასმული კითხვები</span>
                  </a>
                </div>

                   <div className={styles.footer__leftSide__CookiesPolicy}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://xeloba.ge/cookies-policy"
                  >
                    <span>Cookie პოლიტიკა</span>
                  </a>
                </div>
              </div>
            </div>

            <div className={styles.footer__rightSide}>
              <div className={styles.footer__rightSide__childContainer}>
                <div className={styles.footer__rightSide__location}>
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className={styles.faLocationDot}
                  />
                  <span> ქ. თბილისი, რეზო გაბაშვილის N10</span>
                </div>

                <div
                  className={styles.footer__rightSide__contact}
                  onClick={() => handleEmailClick("info@xeloba.ge")}
                >
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className={styles.faEnvelope}
                  />
                  <EmailObfuscate email="info@xeloba.ge" />
                </div>

                <div
                  className={styles.footer__rightSide__contact}
                  onClick={() => handleCallClick()}
                >
                  <FontAwesomeIcon
                    icon={faSquarePhone}
                    className={styles.faSquarePhone}
                  />
                  <span>550 05 91 96</span>
                </div>

                <div className={styles.footer__rightSide__socialNetworks}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/people/%E1%83%AE%E1%83%94%E1%83%9A%E1%83%9D%E1%83%91%E1%83%90-Xeloba/61555048217915/"
                  >
                    <FontAwesomeIcon
                      icon={faSquareFacebook}
                      className={styles.faFacebook}
                    />
                  </a>

                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/xeloba2025/"
                  >
                    <FontAwesomeIcon
                      icon={faSquareInstagram}
                      className={styles.faSquareInstagram}
                    />
                  </a>

                  <FontAwesomeIcon
                    icon={faSquareWhatsapp}
                    className={styles.faSquareWhatsapp}
                    onClick={() => handleWhatsAppClick("550059196")}
                  />

                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/channel/UCw2FaN93hRIK48bKZvYq6nw"
                  >
                    <FontAwesomeIcon
                      icon={faSquareYoutube}
                      className={styles.faSquareYoutube}
                    />
                  </a>
                </div>
              </div>
            </div>
          </footer>
        </div>

        <div className={styles.paymentInfoContainer}>
          <div className={styles.cardIconsContainer}>
            <div className={styles.cardIcons}>
              <FontAwesomeIcon icon={faCcAmex} className={styles.faCcAmex} />

              <FontAwesomeIcon icon={faCcVisa} className={styles.faCcVisa} />

              <FontAwesomeIcon
                icon={faCcMastercard}
                className={styles.faCcMastercard}
              />
            </div>
          </div>
        </div>

        <div className={styles.copyright}>
          <div className={styles.copyright__text}>
            <FontAwesomeIcon
              icon={faCopyright}
              className={styles.faCopyright}
            />
            <span>{`2025 "xeloba.ge" ყველა უფლება დაცულია`}</span>
          </div>
        </div>

        <div className={styles.creatorContainer}>
          <div className={styles.creator}>
            <p>Developed By:</p>
            <p>Giorgi Otarashvili</p>
            {/* <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/gio-otarashvili-ba2175271?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
            >
              <FontAwesomeIcon
                icon={faLinkedin}
                className={styles.devsocialNetwork}
              />
            </a> */}

            <FontAwesomeIcon
              icon={faEnvelope}
              className={styles.devsocialNetwork}
              onClick={() => handleEmailClick("giootarashvili77@gmail.com")}
            />

            <FontAwesomeIcon
              icon={faSquareWhatsapp}
              className={styles.devsocialNetwork}
              onClick={() => handleWhatsAppClick("511410903")}
            />
          </div>
        </div>

        <div className={styles.counterContainer}>
          <div className={styles.counter}>
            <TopGeCounter />
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
